<template>
  <v-dialog v-model="showDialog" width="500" persistent>
    <v-card
      ><v-card-title class="headline">Send Quiz Result</v-card-title>
      <v-card-text>
        <v-text-field
          label="Email"
          dense
          flat
          hide-details
          single-line
          type="email"
          required
          v-model="email"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="closeDialog"> Cancel </v-btn>
        <v-btn small @click="sendResult" color="primary"> Send Result </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SendQuizResultDialog',
  props: {
    showDialog: {
      default: false,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
  },
  computed: {
    user() {
      return this.$auth.user();
    },
    email() {
      return this.user.email;
    },
  },
  methods: {
    sendResult() {
      this.$emit('returnEmail', this.email);
      this.closeDialog();
    },
  },
};
</script>

<style scoped></style>
